import { AdvancedMarker, useMap } from "@vis.gl/react-google-maps";
import { useState, useEffect } from "react";

function Markers({ markers }) {
  const map = useMap();
  const [zoom, setZoom] = useState(null);

  useEffect(() => {
    if (!map) return;

    const listener = map.addListener("zoom_changed", () => {
      setZoom(map.getZoom());
    });

    // Imposta inizialmente lo zoom
    setZoom(map.getZoom());

    return () => listener.remove();
  }, [map]);

  return (
    <>
      {markers.map((marker) => {
        const showPrice = zoom >= 13;
        const vendita_privata = marker.vendita_privata;
        let bg = "#BB005F";
        let type = "vendita";
        if (vendita_privata) {
          bg = "#274E9D";
          type = "privati";
        } else {
          if (marker.tipologia_contratto === "affitto") {
            bg = "#88a650";
            type = "affitto";
          } else {
            bg = "#BB005F";
            type = "vendita";
          }
        }

        return (
          <AdvancedMarker key={marker.id} position={marker.position}>
            {showPrice ? (
              <div
                className={`marker_pill ${type}`}
                style={{
                  backgroundColor: bg,
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                }}
              >
                {marker.prezzo > 0 ? marker.prezzo + "€" : "su Richiesta"}
                {marker.tipologia_contratto === "vendita" ? "" : "/mese"}
              </div>
            ) : (
              <div
                style={{
                  width: "14px",
                  height: "14px",
                  backgroundColor: bg,
                  borderRadius: "50%",
                  border: "2px solid white",
                  boxShadow: "0 0 4px rgba(0,0,0,0.4)",
                }}
              />
            )}
          </AdvancedMarker>
        );
      })}
    </>
  );
}

export default Markers;
